export const PAGES_MAIN_TITLE = 'Pensión mínima objetivo';